export const flow = {
    "activeflow": {
        "activeflow01": "流程關卡",
        "activeflow02": "流程代碼",
        "activeflow03": "目前流程關卡",
        "activeflow04": "最新簽核時間"
    },
    "flowDetail": {
        "flowDetail01": "確定要取消流程嗎？",
        "flowDetail02": "確定要重設流程嗎？",
        "flowDetail03": "確定要取消分會流程嗎？",
        "flowDetail04": "取消流程",
        "flowDetail05": "重設流程",
        "flowDetail06": "取消分會流程",
        "flowDetail07": "流程關卡",
        "flowDetail08": "流程代碼",
        "flowDetail09": "簽核狀態",
        "flowDetail10": "簽核時間",
        "flowDetail11": "分會流程關卡",
        "flowDetail12": "分會流程代碼",
        "flowDetail13": "分會簽核狀態",
        "flowDetail14": "分會簽核時間"
    },
    "flowRole": {
        "flowRole01": "角色代碼",
        "flowRole02": "角色名稱",
        "flowRole03": "帳號數",
        "flowRole04": "流程角色-新增",
        "flowRole05": "流程角色-修改"
    },
    "flowSet": {
        "flowSet01": "流程設定-新增",
        "flowSet02": "流程設定-修改",
        "flowSet03": "流程關卡設定-新增",
        "flowSet04": "流程關卡設定-修改",
        "flowSet05": "流程名稱",
        "flowSet06": "流程說明",
        "flowSet07": "是否啟用",
        "flowSet08": "啟用",
        "flowSet09": "停用",
        "flowSet10": "表單數",
        "flowSet11": "新增關卡",
        "flowSet12": "關卡名稱",
        "flowSet13": "MAIL通知",
        "flowSet14": "是否決行",
        "flowSet15": "是否簽章",
        "flowSet16": "檢查憑證",
        "flowSet17": "是否封存",
        "flowSet18": "流程代碼",
        "flowSet19": "有效日期",
        "flowSet20": "請選擇",
        "flowSet21": "角色選單必填",
        "flowSet22": "流程選單必填",
        "flowSet23": "角色",
        "flowSet24": "使用者",
        "flowSet25": "流程",
        "flowSet26": "關卡設定",
        "flowSet27": "使用者選單必填"
    }
}